export default "__VITE_PUBLIC_ASSET__eeba0065__"